import {
  MEZO_STABLECOINS,
  MezoStablecoins,
  STBTC_TOKENS,
  StbtcTokens,
  SupportedTokenName,
} from "@mezo/sdk"

import bitcoinTokenLogo from "#/assets/tokens/bitcoin-token.svg"
import {
  ALL_TOKENS,
  bridge,
  MEZO_ASSETS,
  ONE_BITCOIN_IN_SATOSHI,
  TOKEN_TO_SYMBOL,
} from "#/shared/constants"

export const convertBitcoinToSatoshi = (amount: number | string): bigint =>
  BigInt(Math.round(Number(amount) * ONE_BITCOIN_IN_SATOSHI))

export const convertSatoshiToBitcoin = (amount: bigint): number =>
  Number(amount) / ONE_BITCOIN_IN_SATOSHI

export const getTokenIcon = (token: SupportedTokenName): string =>
  ALL_TOKENS.find(({ token: tokenName }) => token === tokenName)?.icon ??
  // If the token icon is not found, we should default to displaying bitcoin icon
  bitcoinTokenLogo

export const getCurrencySymbol = (token: SupportedTokenName) =>
  TOKEN_TO_SYMBOL[token]

export const isStablecoin = (tokenName: SupportedTokenName): boolean =>
  MEZO_STABLECOINS.includes(tokenName as keyof MezoStablecoins)

export const isStbtcToken = (tokenName: SupportedTokenName): boolean =>
  STBTC_TOKENS.includes(tokenName as unknown as keyof StbtcTokens)

export const isBitcoinToken = (tokenName: SupportedTokenName): boolean =>
  !isStablecoin(tokenName) &&
  !isStbtcToken(tokenName) &&
  getCurrencySymbol(tokenName) !== "MUSD"

export const isTokenEligibleForUnlocks = (
  tokenName: SupportedTokenName,
): boolean => isBitcoinToken(tokenName) || tokenName === "crv-stBTC"

export const isBridgeableToken = (tokenName: SupportedTokenName): boolean =>
  Object.keys(bridge.BRIDGEABLE_TOKENS).includes(tokenName)

export const getMezoTokenName = (token: SupportedTokenName): string | null => {
  const { tokenName } = MEZO_ASSETS[token] ?? { tokenName: null }

  return tokenName
}
